import { render, staticRenderFns } from "./ProjectsTableRow.vue?vue&type=template&id=0107182d&scoped=true"
import script from "./ProjectsTableRow.vue?vue&type=script&lang=js"
export * from "./ProjectsTableRow.vue?vue&type=script&lang=js"
import style0 from "./ProjectsTableRow.vue?vue&type=style&index=0&id=0107182d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0107182d",
  null
  
)

export default component.exports